import { Dayjs } from 'dayjs'
import { request } from '../request'
import Constants from '@helpers/Constants'
import { ExtremaduraBulletinRequestParamsDTO } from '@models/api/ExtremaduraBulletinRequestParamsDTO'

export const meteogram = {
  getMeteograma: function (
    lat: string | number,
    lon: string | number,
    idModel: string,
    dateOut: Dayjs
  ) {
    return request.get(
      `api/getMeteogram?lat=${lat}&lon=${lon}&date=${dateOut
        .utc()
        .format('YYYY-MM-DD')}&out=${dateOut
        .utc()
        .format('HH')}&model=${idModel}`
    )
  },

  getReportMeteograma: function (
    parameters: ExtremaduraBulletinRequestParamsDTO
  ) {
    let url = `${Constants.apiURL}/personalizedBulletin`

    const transformedParams = {
      ...parameters,
      date: parameters.date.toISOString()
    }
    return request.get<File | BlobPart>(url, {
      params: transformedParams,
      responseType: 'blob'
    })
  }
}
